export default __webpack_public_path__ + "static/media/DOPPLE-DOLLY-LP.eb3a9d8d.svg";